import React from 'react'
import { styled } from '@mui/material/styles'
import Switch from '@mui/material/Switch'
import { FormControlLabel, Typography, TypographyProps } from '@mui/material'
import { COLORS } from 'app-constants'

const StyledSwitch = styled(Switch)(({ theme }) => ({
  width: 33,
  height: 18,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 14,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(15px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(15px)',
      color: COLORS.PURE_WHITE,
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: COLORS.JELLED_PRIMARY_BLUE,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    width: 14,
    height: 14,
    boxShadow: 'none',
    borderRadius: 7,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 18 / 2,
    opacity: 1,
    backgroundColor: 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
  },
  '.Mui-disabled & .MuiSwitch-track': {
    border: '2px solid #A0A0A0',
    backgroundColor: 'white',
  },
}))

export default function JelledSwitch({
  label,
  checked,
  onChange,
  disabled,
  typographyProps,
  name,
  className,
  style,
}: {
  label: React.ReactNode
  checked: boolean
  onChange: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void
  disabled?: boolean
  typographyProps?: TypographyProps
  name?: string | undefined
  className?: string
  style?: React.CSSProperties
}) {
  return (
    <FormControlLabel
      sx={{ margin: 0, '.MuiFormControlLabel-label': { flex: '1 1', width: '100%' } }}
      control={<StyledSwitch checked={checked} onChange={onChange} disabled={disabled} />}
      label={
        typeof label === 'string' ? (
          <Typography variant="pS" {...typographyProps} width="100%">
            {label}
          </Typography>
        ) : (
          label
        )
      }
      labelPlacement="start"
      name={name}
      className={className}
      style={style}
    />
  )
}

JelledSwitch.defaultProps = {
  typographyProps: { variant: 'pS' },
}
